const THREE = window.THREE
const genUuid = () => {
  var s = []

  var hexDigits = '0123456789abcdef'

  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }

  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010

  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01

  s[8] = s[13] = s[18] = s[23] = '-'

  var uuid = s.join('')

  return uuid.toUpperCase()
}

const rgbaToHex = (red, green, blue) => {
  const color = new THREE.Color()
  color.setRGB(red / 255, green / 255, blue / 255)
  return color.getHex()
}

const decodeImage = async(url) => {
  var p = new Promise(function(resolve, reject) {
    var loader = new window.CryptoResourceLoader()
    loader.loadURL(url, resolve, reject)
  })
  const data = await p
  return data
}

const blobToDataURL = async(blob) => {
  var p = new Promise(function(resolve) {
    // var p = new Promise(function (resolve, reject) {
    const a = new FileReader()
    a.onload = function(e) { resolve(e.target.result) }
    a.readAsDataURL(blob)
  })
  const data = await p
  return data
}

const arrGroup = (array, subGroupLength) => {
  let index = 0
  const newArray = []
  while (index < array.length) {
    newArray.push(array.slice(index, index += subGroupLength))
  }
  return newArray
}

export default {
  genUuid,
  rgbaToHex,
  decodeImage,
  blobToDataURL,
  arrGroup
}
